module.exports = __webpack_public_path__ + "img/roulette-card-spade.881e1ff8.svg";